import { createContext, useContext } from "react";

// Create UsersContext
export const UsersContext = createContext();

// Custom hook to use UsersContext
export const useUsers = () => useContext(UsersContext);
